import apiClient from './client';
import { getApiBaseUrl } from './client';

export const getHealth = () => apiClient.get('/api/health').then(r => r.data);
export const getDetailedHealth = () => apiClient.get('/api/health/detailed').then(r => r.data);

export const dealDamage = (amount, source) =>
  apiClient.post('/api/health/damage', { amount, source }, { _skipAuthRedirect: true }).then(r => r.data);

export const healHP = (amount, source) =>
  apiClient.post('/api/health/heal', { amount, source }, { _skipAuthRedirect: true }).then(r => r.data);

export const revivePlayer = (method) =>
  apiClient.post('/api/health/revive', { method }).then(r => r.data);

/**
 * Create an EventSource for real-time HP updates.
 * Returns the EventSource instance (caller must close it).
 */
export function createHealthStream(token) {
  const base = getApiBaseUrl();
  const url = `${base}/api/health/stream`;
  // EventSource doesn't support Authorization header natively,
  // so we use fetch-based SSE via a ReadableStream wrapper.
  return new HealthSSE(url, token);
}

/**
 * Minimal SSE client that supports Authorization header.
 * EventSource API doesn't allow custom headers, so we use fetch.
 */
class HealthSSE {
  constructor(url, token) {
    this._url = url;
    this._token = token;
    this._abortController = new AbortController();
    this._onmessage = null;
    this._onerror = null;
    this._closed = false;
    this._connect();
  }

  set onmessage(fn) { this._onmessage = fn; }
  set onerror(fn) { this._onerror = fn; }

  close() {
    this._closed = true;
    this._abortController.abort();
  }

  async _connect() {
    while (!this._closed) {
      try {
        const response = await fetch(this._url, {
          headers: { 'Authorization': `Bearer ${this._token}` },
          signal: this._abortController.signal,
        });
        if (!response.ok) {
          throw new Error(`SSE HTTP ${response.status}`);
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (!this._closed) {
          const { done, value } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop(); // Keep incomplete line in buffer
          for (const line of lines) {
            if (line.startsWith('data: ') && this._onmessage) {
              try {
                const data = JSON.parse(line.slice(6));
                this._onmessage({ data });
              } catch { /* ignore malformed */ }
            }
          }
        }
      } catch (err) {
        if (this._closed) return;
        if (this._onerror) this._onerror(err);
        // Reconnect after 5s
        await new Promise(r => setTimeout(r, 5000));
      }
    }
  }
}
